import { useEffect } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { autoRefreshUsers } from "../../../redux/SettingModule/UsersPage/UsersAction";

function AutoRefreshUsers() {
  const dispatch = useAppDispatch();
  const autoRefreshState = useSelector((state: RootState) => state.UsersPageState.autoRefreshUsersState);

  useEffect(() => {
    dispatch(autoRefreshUsers({}));
  }, [autoRefreshState.autoRefresh]);

  return null;
}

export default AutoRefreshUsers;
